<template>
  <div>
    <div id="modelZz" class="modelZz" @click="handleModelZz"></div>
    <div id="menu" class="nav-menu">
      <div class="nav-menu-content">
        <div
          v-if="isMobile"
          style="
            display: flex;
            cursor: pointer;
            padding: 10px;
            border-bottom: 1px solid #ddd;
          "
          @click="handleCommand('Home')"
        >
          <img
            class="logo"
            src="../../icons/svg/cosmoplat.svg"
            style="width: auto; height: 36px"
          />
          <div
            style="
              width: 1px;
              height: 40px;
              background-color: #ddd;
              margin-left: 13px;
              margin-right: 13px;
            "
          ></div>
          <img
            class="logo"
            src="../../icons/svg/haimozhiyun.svg"
            style="width: auto; height: 32px; padding-top: 5px"
          />
        </div>
        <!-- :unique-opened="true" -->
        <el-menu
          :default-active="defaultUrl"
          class="m-header-nav"
          :mode="isMobile ? 'vertical' : 'horizontal'"
          background-color="#fff"
          text-color="#333"
          active-text-color="rgba(0, 132, 255, 1)"
          :router="true"
        >
          <el-menu-item index="/">
            <template slot="title">
              <span class="icon iconfont icon-home"></span>
              <span>Home</span>
            </template>
          </el-menu-item>
          <el-submenu index="/about">
            <template slot="title">
              <span class="icon iconfont icon-AboutUs"></span>
              <span>About Us</span>
            </template>
            <el-menu-item
              v-for="menu in aboutUsMenu"
              :key="menu.id"
              :index="menu.index"
              >{{ menu.name }}</el-menu-item
            >
          </el-submenu>
          <el-submenu index="/products-and-service">
            <template slot="title">
              <router-link
                class="nav-menu-link"
                :class="{
                  active:
                    $route.name === 'products-list' ||
                    $route.name === 'products-and-service',
                }"
                to="/products-and-service"
              >
                <span class="icon iconfont icon-ProductsandService"></span>
                <span>Products and Service</span>
              </router-link>
            </template>
            <el-menu-item
              v-for="menu in productsServiceMenu"
              :key="menu.id"
              :index="
                menu.url ||
                `/products-list/${menu.name
                  .split(' ')
                  .map((item) => item.toLowerCase())
                  .join('-')}/${menu.id}`
              "
              >{{ menu.name }}</el-menu-item
            >
            <el-menu-item index="/home/after-sale-service"
              >After-Sale Service</el-menu-item
            >
          </el-submenu>
          <el-submenu index="/Suppliers">
            <template slot="title">
              <span class="icon iconfont icon-Suppliers"></span>
              <span>Suppliers</span>
            </template>
            <el-menu-item
              v-for="menu in suppliersMenu"
              :key="menu.id"
              :index="`/suppliers/${menu.category}/${menu.id}`"
              >{{ menu.name }}</el-menu-item
            >
          </el-submenu>
          <el-submenu index="/CapacityWarranty">
            <template slot="title">
              <span class="icon iconfont icon-CapacityWarranty"></span>
              <span>Capacity Warranty</span>
            </template>
            <el-menu-item
              v-for="menu in capacityMenu"
              :key="menu.id"
              :index="menu.index"
              >{{ menu.name }}</el-menu-item
            >
          </el-submenu>
          <!-- <el-menu-item index="/ContactUs" @click="handleJumpSingle('/ContactUs',4)">
        <template slot="title">
          <span class="icon iconfont icon-ContactUs"></span>
          <span>Contact Us</span>
        </template>
      </el-menu-item> -->
          <el-menu-item index="/products-list/epidemic-prevention-materials/-1">
            <template slot="title">
              <span class="icon iconfont icon-OtherHotSupplies"></span>
              <span>Other Hot Supplies</span>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import "./_NavMenu.scss";
import { palFormUrl } from "../../config/appConfig";
import { customFetch } from "../../utils/api";
import bus from "../../utils/eventBus.js";
import { aboutUsMenu, suppliersMenu, capacityMenu } from "./menu.js";

export default {
  name: "NavMenu",
  components: {},
  props: {
    mode: {
      type: String,
      default: "horizontal",
    },
  },
  data() {
    return {
      // activeIndex: "Home",
      visible: false,
      showMessageFrom: false,
      defaultUrl: "/",
      aboutUsMenu,
      suppliersMenu,
      capacityMenu,
      modelZz: "",
      menuBox: "",
    };
  },
  computed: {
    activeRouter() {
      return this.$route.path;
    },
    productsServiceMenu() {
      return this.$store.state.allCategories;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  watch: {
    "$route.query": function (newVal, oldVal) {
      this.getPath();
    },
  },
  created() {
    if (
      !this.$store.state.allCategories ||
      this.$store.state.allCategories.length == 0
    ) {
      this.$store.dispatch("getAllCategories");
    }
  },
  mounted() {
    this.menuBox = document.getElementById("menu");
    this.modelZz = document.getElementById("modelZz");
    bus.$on("setOpenStatus", (data) => {
      console.log(data);
      if (data) {
        this.menuBox.style["display"] = "block";
        this.modelZz.style["display"] = "block";
      } else {
        this.menuBox.style["display"] = "none";
      }
    });
  },
  methods: {
    hideMenu() {
      if (this.isMobile) {
        this.menuBox.style["display"] = "none";
        this.modelZz.style["display"] = "none";
      }
    },
    handleModelZz() {
      this.menuBox.style["display"] = "none";
      this.modelZz.style["display"] = "none";
    },
    handleJumpSingle(path, type) {
      type
        ? this.$router.push({
            path: "/ContactUs",
            query: {
              type: 4,
            },
          })
        : this.$router.push({
            path: path,
          });

      this.hideMenu();
    },
    handleJump(name, jumpType) {
      this.$router.push({
        path: name,
      });
      this.hideMenu();
    },
    handleJumpCategory(item) {
      this.$router.push({
        path: item.url,
        query: {
          categoryId: item.id,
          name: item.name,
        },
      });
      this.hideMenu();
    },
    handleJumpWorld() {
      this.$router.push({
        name: "Home",
        query: {
          anchorName: "worldInsertCharts",
        },
      });
      this.hideMenu();
    },
    handleJumpAbout(menu) {
      this.$router.push({
        path: menu.index,
        query: {
          type: menu.anchorName,
        },
      });
      this.hideMenu();
    },
    handleJumpFire(menu) {
      this.$router.push({
        name: "Home",
        query: {
          anchorName: menu.anchorName,
          anchorNameType: "GolobalAftersale",
        },
      });
      this.hideMenu();
    },
    getPath() {
      this.defaultUrl = this.$route.path;
    },
    handleCommand(command) {
      if (this.$route.name === command) {
        window.location.reload();
      } else {
        this.$router.push({
          name: command,
        });
      }
      this.hideMenu();
    },
    goRouter() {
      this.$router.push("/products-and-service");
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../scss/global";
.m-header-nav {
  .el-menu-item {
    font-size: 16px;
    color: #2f3440;
    padding: 0 10px;
    background-color: #434343;

    &:hover {
      color: #4da5f7;
    }
  }

  .el-submenu {
    .el-submenu__title {
      font-size: 16px;
      color: #2f3440;
      padding: 0 15px;
      height: 50px;
      line-height: 50px;
      margin-top: 5px;
      background-color: #434343;

      &:hover {
        color: #4da5f7;
      }
    }
  }
}

.nav-menu-link {
  text-decoration: none;
  color: rgb(51, 51, 51);
}

.nav-menu-link.active {
  color: rgb(0, 132, 255);
}

.menu-icon {
  width: 18px;
  padding-right: 5px;
}

.el-menu.el-menu--horizontal {
  border-bottom: solid 0px #e6e6e6;
}

/deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 0px solid #0084ff;
  color: #303133;
  border-bottom-color: #303133;
}

/deep/ .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px solid #0084ff;
  border-bottom-color: #303133;
  color: #303133;
}
.modelZz {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 500;
  display: none;
}
.nav-menu {
  z-index: 99999;
}
.nav-menu-content {
  z-index: 10000;
}
@media screen and (max-width: 990px) {
  .nav-menu {
    position: fixed;
    margin: 0;
    width: 80%;
    justify-content: left;
    font-size: 1rem;
    text-align: left;
    height: 100vh;
    z-index: 10000;
    background-color: #fff;
    top: 0;
    display: none;
    .nav-menu-content {
      position: absolute;
      top: 0;
      overflow-y: auto;
      overflow-x: hidden;
      width: 100%;
      height: 100vh;
    }
  }
  .el-menu-item {
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }
}
</style>
